@if(mode==="read"){
<div class="ppl-mt8">
    <h2>Associations</h2>
</div>
@if(flow === 'participantEnrollment'){
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="participantAssociations"
    [disableSelection]="true" [cols]="participantCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
    [actionButtons]="null">
</ppl-list-table>
}
@if(flow === 'providerEnrollment'){
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="associations"
    [disableSelection]="true" [cols]="associationCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
    [actionButtons]="null"></ppl-list-table>
}
}
@else{
<div class="ppl-mt8">
    <h2>Add Associations</h2>
</div>
@if(isStepMandatory){
<div class="ppl-form-item">
    <p class="info-box">
        <i class="fa fa-info-circle" aria-hidden="true"></i> <span>Please add at least one association</span>
    </p>
</div>
}
<div class="ppl-mt16 btn-group" style="display: flex; gap: 8px;">
    <!-- <button nzType="primary" class="ppl-mr16 btn-hide" nz-button [nzSize]="'small'" (click)="expandAll()">Expand
      All</button>
    <button nzType="primary" nz-button class="btn-hide" [nzSize]="'small'" (click)="hideAll()">Hide All</button> -->
    <ppl-button label="Expand All" icon="fa fa-expand" [customClass]="'alt-button'" [iconPosition]="'right'"
        (click)="expandAll()"></ppl-button>
    <ppl-button label="Collapse All" icon="fa fa-compress" [customClass]="'alt-button'" [iconPosition]="'right'"
        (click)="hideAll()"></ppl-button>
</div>
<div>
    <form nz-form [formGroup]="newContactForm" class="ppl-p0 association-form" appAutoFocusFirstInput>
        <nz-collapse [nzExpandIconPosition]="'end'">
            @if(isAttrAvailable('newAuthRep')){
            <nz-collapse-panel [nzHeader]="'Authorized Representative'" [nzActive]="isPanelActive('1')"
                (nzClick)="togglePanel('1')">
                @if (getProviderData('AR').length > 0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('AR')" [disableSelection]="true" [cols]="getProviderColumns('AR')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                @if(allowMultiple['AR']) {
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'"
                        (click)="addAssociation('authRepresentative', editMode.Search)"></ppl-button>
                    <ppl-button label="Add Authorized Representative" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('authRepresentative')"></ppl-button>
                </div>
                }
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newEmployer') && !isGoodsAndServicesOnly){
            <nz-collapse-panel [nzHeader]="'Employer'" [nzActive]="isPanelActive('2')"
                (nzClick)="togglePanel('2')" [ngClass]="{'error': !isEmpValid }">
                @if(!isEmpValid) {
                    <div class="w-100 alert alert-danger">{{empValidationErrorMessage}}</div>
                }
                @if (getProviderData('EMP').length >0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('EMP')" [disableSelection]="true" [cols]="getProviderColumns('EMP')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                @if(allowMultiple['EMP']) {
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('employer', editMode.Search)"></ppl-button>
                    <ppl-button label="Add Employer" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('employer')"></ppl-button>
                </div>
                }
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newIndependentProvider') && !isGoodsAndServicesOnly){
            <nz-collapse-panel [nzHeader]="'Independent Provider'" [nzActive]="isPanelActive('3')"
                (nzClick)="togglePanel('3')">
                @if (getProviderData('IR').length >0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('IR')" [disableSelection]="true" [cols]="getProviderColumns('IR')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                <div class="actions-container">
                    @if(!viewport.isMobileView()) {
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('provider', editMode.Search)"></ppl-button>
                    }
                    <ppl-button label="Add Independent Provider" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('provider', editMode.Edit)"></ppl-button>
                </div>
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newIndependentContractor')){
            <nz-collapse-panel [nzHeader]="'Independent Contractor'" [nzActive]="isPanelActive('4')"
                (nzClick)="togglePanel('4')">
                @if (getProviderData('IC').length >0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('IC')" [disableSelection]="true" [cols]="getProviderColumns('IC')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('contractor', editMode.Search)"></ppl-button>
                    <ppl-button label="Add Independent Contractor" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('contractor')"></ppl-button>
                </div>
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newVendor')){
            <nz-collapse-panel [nzHeader]="'Vendor'" [nzActive]="isPanelActive('5')"
                (nzClick)="togglePanel('5')">
                @if (getProviderData('VE').length >0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('VE')" [disableSelection]="true" [cols]="getProviderColumns('Vendor')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('vendor', editMode.Search)"></ppl-button>
                    <ppl-button label="Add Vendor" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('vendor')"></ppl-button>
                </div>
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newIndependentFacilitator')){
            <nz-collapse-panel [nzHeader]="'Independent Facilitator'" [nzActive]="isPanelActive('6')"
                (nzClick)="togglePanel('6')">
                @if (getProviderData('IF').length >0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('IF')" [disableSelection]="true" [cols]="getProviderColumns('IF')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                @if(allowMultiple['IF']) {
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('independentFacilitator', editMode.Search)"></ppl-button>
                    <ppl-button label="Add Independent Facilitator" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('independentFacilitator')"></ppl-button>
                </div>
                }
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newPOA')){
            <nz-collapse-panel [nzHeader]="'POA'" [nzActive]="isPanelActive('7')" (nzClick)="togglePanel('7')">
                @if (getProviderData('POA').length > 0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('POA')" [disableSelection]="true" [cols]="getProviderColumns('POA')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                @if(isParticipantMinor){
                    <nz-alert nzType="info" nzMessage="Participant is a minor. Adding a POA is not allowed." nzShowIcon></nz-alert>
                }
                @if(allowMultiple['POA']) {
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('poa', editMode.Search)"></ppl-button>
                    <ppl-button label="Add POA" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
                        (click)="addAssociation('poa')"></ppl-button>
                </div>
                }
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newLegalGuardian')){
            <nz-collapse-panel [nzHeader]="'Legal Guardian'" [nzActive]="isPanelActive('8')"
                (nzClick)="togglePanel('8')">
                @if (getProviderData('LG').length > 0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('LG')" [disableSelection]="true" [cols]="getProviderColumns('LG')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                @if(allowMultiple['LG']) {
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('legalGuardian', editMode.Search)"></ppl-button>
                    <ppl-button label="Add Legal Guardian" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('legalGuardian')"></ppl-button>
                </div>
                }
            </nz-collapse-panel>
            }
            @if(isAttrAvailable('newConservator')){
            <nz-collapse-panel [nzHeader]="'Conservator'" [nzActive]="isPanelActive('9')" (nzClick)="togglePanel('9')">
                @if (getProviderData('CNV').length > 0) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                    [data]="getProviderData('CNV')" [disableSelection]="true" [cols]="getProviderColumns('CNV')"
                    [gridTitle]="false" [pagination]="true" [loadPage]="false" [actionButtons]="actions"
                    (gridAction)="action($event)" [pagination]="false">
                </ppl-list-table>
                }
                @if(isParticipantMinor){
                    <nz-alert nzType="info" nzMessage="Participant is a minor. Adding a Conservator is not allowed." nzShowIcon></nz-alert>
                }
                @if(allowMultiple['CNV']) {
                <div class="actions-container">
                    <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('conservator', editMode.Search)"></ppl-button>
                    <ppl-button label="Add Conservator" icon="fa fa-plus" [customClass]="'ghost-button'"
                        [iconPosition]="'left'" (click)="addAssociation('conservator')"></ppl-button>
                </div>
                }
            </nz-collapse-panel>
            }
        </nz-collapse>
    </form>
</div>
}

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> Are you sure you want to remove this association ?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #deleteConfirmationDialog let-cancel="cancel">
        <p> Participants under the age of 18 are required to have at least one Designated Representative. </p>
        <p> Please add a new Designated Representative before removing the existing one. </p>
    </ng-template>
</div>